import {ErrorMessage} from "formik";


const FieldError = ({name}) => <ErrorMessage name={name}>
    {msg => <div className="errorMessage">{msg?.join ? msg.join(", ") : msg}</div>}
</ErrorMessage>;

export default FieldError;